@if (isShown) {
  <udex-message-strip
    class="body--s"
    (close)="closeMessage()"
    design="Warning"
    status-type="Icon"
    [attr.data-cy]="'outdated-cart-message'">
    <span style="vertical-align: middle">{{ message }}</span>
  </udex-message-strip>
}
